import React from 'react';
import style from "./BotaoPaginaNovo.module.css"
import { Link } from "react-router-dom";

function BotaoPaginaNovo({ link, state }) {

    return (
        <Link
            to={link}
            state={state}
            className={style.botao_novo}
        >
            + Novo
        </Link>
    );
}
export default BotaoPaginaNovo;
